import api from '@services/api';
import { DetailsClassificationBaseResponse } from '../models/contractType';

/**
 * <p>
 * API endpoints that cover all financial classification related CRUD calls
 */
export const financialClassificationApi = api.injectEndpoints({
  endpoints: (builder) => ({
    searchContractType: builder.query<DetailsClassificationBaseResponse[], void>({
      query: () => ({
        url: encodeURI(`/report/contract-type/list`),
      }),
      providesTags: ['SearchContractType'],
    }),
    searchEquipmentClassification: builder.query<DetailsClassificationBaseResponse[], void>({
      query: () => ({
        url: encodeURI(`/report/equipment-classification/list`),
      }),
      providesTags: ['SearchEquipmentClassification'],
    }),
    searchEquipmentAppropriation: builder.query<DetailsClassificationBaseResponse[], void>({
      query: () => ({
        url: encodeURI(`/report/equipment-appropriation/list`),
      }),
      providesTags: ['SearchEquipmentAppropriation'],
    }),
    searchSchoolLavel: builder.query<DetailsClassificationBaseResponse[], void>({
      query: () => ({
        url: encodeURI(`/report/school-level/list`),
      }),
      providesTags: ['SearchSchoolLavel'],
    }),
  }),
});

export const {
  useSearchContractTypeQuery,
  useSearchEquipmentClassificationQuery,
  useSearchEquipmentAppropriationQuery,
  useSearchSchoolLavelQuery,
} = financialClassificationApi;
